export enum SpotpriceArea {
	NO1 = "NO1",
	NO2 = "NO2",
	NO3 = "NO3",
	NO4 = "NO4",
	NO5 = "NO5",
}

const DISPLAY_NAMES: Record<SpotpriceArea, string> = {
	[SpotpriceArea.NO1]: "Øst-Norge",
	[SpotpriceArea.NO2]: "Sør-Norge",
	[SpotpriceArea.NO3]: "Midt-Norge",
	[SpotpriceArea.NO4]: "Nord-Norge",
	[SpotpriceArea.NO5]: "Vest-Norge",
};

/** Options for a select, e.g. "NO3 – Midt-Norge". */
export const spotpriceAreaOptions = Object.values(SpotpriceArea).map((area) => ({
	value: area,
	label: `${area} – ${DISPLAY_NAMES[area]}`,
}));
